import { Pressable, FlatList, View, Image } from "react-native";
import { FindifyTopBarOverlay } from "./components/FindifyTopBarOverlay";
import React, { useContext, useEffect, useState } from "react";
import { PlaceColors } from "./helpers/PlaceColors";
import { BasePage } from "./helpers/BasePage";
import { useTranslation } from "react-i18next";
import { FindifySimpleHeader, SimpleHeaderAction } from "./components/FindifySimpleHeader";
import { FindifyDataContext, FindifyDataContextType } from "@/contexts/FindifyDataContext";
import { PlaceText } from "./components/PlaceText";
import { BaseFindifyList } from "./components/FindifyList";
import { getTranslatedString } from "./helpers/FindifyTranslatedString";
import { PlaceListInitialUseEffect, PlaceListOnSelectedCategoryChangeEffect, loadContentsPageFromApi } from "@/layouts/genericPages/helpers/PlaceListHelper";
import { DefaultShadow } from "./helpers/DefaultShadows";
import { FindifyBasicModal } from "./components/FindifyBasicModal";
import { getFeaturedImageUrl, makeDateString } from "./helpers/DetailsHelpers";

export const UserOrdersPage = ({ navigation, ...props }: any) => {
    const [contents, setContents] = useState([]);
    const { t } = useTranslation();
    const [module, setModule] = useState('');
    const [selectedCategories, setSelectedCategories] = useState<number[]>([]);
    const findifyDataContext = useContext(FindifyDataContext);
    const [loaded, setLoaded] = useState(false);
    const [availableModuleCategories, setAvailableModuleCategories] = useState<any[]>([]);
    const [actionsList, setActionsList] = useState<SimpleHeaderAction[]>([]);
    const [selectedOrder, setSelectedOrder] = useState<any>(undefined);

    useEffect(() => {
        PlaceListInitialUseEffect({
            props,
            setContents,
            setLoaded,
            setModule,
            setSelectedCategories,
            findifyDataContext,
            setAvailableModuleCategories,
            contents,
            ignoreContentsWithoutCategory: false,
            pageModule: 'shop_order',
        });
    }, [])


    useEffect(() => {
        PlaceListOnSelectedCategoryChangeEffect({
            loaded,
            selectedCategories,
            setContents,
            module,
            findifyDataContext,
            setActionsList,
            availableModuleCategories,
            t,
        });
    }, [selectedCategories])


    const header = <FindifySimpleHeader navigation={navigation}
        title={t('modules.user_orders')}
        isEventLayout
        actions={actionsList}
    />;

    return <BasePage navigation={navigation}>
        <FindifyTopBarOverlay />
        <BaseFindifyList
            items={contents.map((ticket: any) => {
                return {
                    ...ticket,
                    onPress: () => { // Set selected ticket to open modal
                        setSelectedOrder(ticket);
                    }
                };
            })}
            header={<>
                {header}
                <FlatList
                    key={'listcategories'}
                    data={availableModuleCategories}
                    horizontal
                    renderItem={({ item, index }) => {
                        const catSelected = selectedCategories.includes(item.category_id);
                        return <Pressable
                            onPress={() => {
                                if (catSelected) {
                                    setSelectedCategories(selectedCategories.filter(cat => cat !== item.category_id));
                                } else {
                                    setSelectedCategories([...selectedCategories, item.category_id]);
                                }
                            }}
                            style={{
                                ...DefaultShadow,
                                borderRadius: 100,
                                backgroundColor: catSelected ?
                                    PlaceColors(findifyDataContext).text.get()
                                    : PlaceColors(findifyDataContext).background.get(),
                                padding: 10,
                                marginVertical: 4,
                                marginLeft: 6,
                            }}
                        >
                            <PlaceText
                                style={{
                                    color: catSelected ?
                                        PlaceColors(findifyDataContext).background.get() :
                                        PlaceColors(findifyDataContext).text.get(),
                                }}
                            >
                                {getTranslatedString(item.name, findifyDataContext)}
                            </PlaceText>
                        </Pressable>;
                    }} />
            </>}
            onEndReached={() => {
                if (loaded) {
                    loadContentsPageFromApi(selectedCategories, contents, module, findifyDataContext, setContents);
                }
            }}
            renderLine={(item, index) => {
                return <Pressable
                    style={{
                        backgroundColor: PlaceColors(findifyDataContext).alternateListBG.get(),
                        margin: 5,
                        borderRadius: 8,
                        paddingVertical: 8,
                        paddingHorizontal: 8,
                        flexDirection: 'row',
                    }}
                    onPress={item.onPress}
                >
                    {item?.ticket_collection_ticket?.ticket_collection?.featured_image_media?.file_path &&
                        <Image style={{
                            width: 100,
                            height: 100,
                            borderRadius: 8,
                            objectFit: 'cover'
                        }} source={{
                            uri: getFeaturedImageUrl(item?.ticket_collection_ticket?.ticket_collection)
                        }} />
                    }
                    <View
                        style={{
                            flexDirection: 'column',
                            marginLeft: 10,
                        }}
                    >
                        <PlaceText style={{
                            color: PlaceColors(findifyDataContext).text.get(),
                            fontSize: 18,
                            fontWeight: 'bold',
                        }}>{makeDateString(new Date(item.order_date))}</PlaceText>
                        <PlaceText style={{
                            color: PlaceColors(findifyDataContext).text.get(),
                            fontSize: 14,
                        }}>Total: {parseFloat(item?.total).toFixed(2)}</PlaceText>
                        <View style={{
                            flexDirection: 'column',
                            gap: 4,
                            marginTop: 'auto'
                        }}>
                            <PlaceText style={{
                                color: PlaceColors(findifyDataContext).text.get(),
                                fontSize: 14,
                            }}>Status: {item.status}</PlaceText>
                        </View>
                    </View>

                </Pressable>;
            }}
            enableGrid={false}
        />
        <UserOrderModal
            selectedOrder={selectedOrder}
            setSelectedOrder={setSelectedOrder}
            findifyDataContext={findifyDataContext}
            t={t}
        />
    </BasePage >;
};


const UserOrderModal = ({ selectedOrder, setSelectedOrder, findifyDataContext, t, }: {
    selectedOrder: any,
    setSelectedOrder: Function,
    findifyDataContext: FindifyDataContextType,
    t: any,
    // label: string,
    // form: any,
    // actions: { onPress: any, label: string }[]
}) => {

    useEffect(() => {
        console.log(JSON.stringify(selectedOrder));
    }, [selectedOrder])

    return <FindifyBasicModal
        isOpen={selectedOrder ? true : false}
        transparent={true}
        // align="flex-end"
        closeModal={() => setSelectedOrder(undefined)}
    >
        <View style={[{
            // marginBottom: insets.bottom + 75, 
            backgroundColor: PlaceColors(findifyDataContext).background.get(),
            padding: 20,
            borderRadius: 10,
            minWidth: '80%',
            gap: 10,
        }]}>
            <View
                style={{
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 4,
                }}
            >
                {selectedOrder?.ticket_collection_ticket?.ticket_collection?.featured_image_url &&
                    <Image style={{
                        width: 100,
                        height: 100,
                        borderRadius: 8,
                        objectFit: 'cover'
                    }} source={{ uri: selectedOrder?.ticket_collection_ticket?.ticket_collection.featured_image_url }} />
                }
                <View
                    style={{
                        flexDirection: 'column',
                        marginLeft: 10,
                    }}
                >
                    <PlaceText style={{
                        color: PlaceColors(findifyDataContext).text.get(),
                        fontSize: 18,
                        fontWeight: 'bold',
                        marginBottom: 18
                    }}>
                        {makeDateString(new Date(selectedOrder?.order_date))}
                    </PlaceText>
                    <View
                        style={{
                            flexDirection: 'column',
                            gap: 4,
                            marginTop: 'auto'
                        }}
                    >
                        <PlaceText style={{
                            color: PlaceColors(findifyDataContext).text.get(),
                            fontSize: 14,
                        }}>Status: {selectedOrder?.status}</PlaceText>
                        {selectedOrder?.shop_order_items.map((shopItem: any) => {
                            return <PlaceText style={{
                                color: PlaceColors(findifyDataContext).text.get(),
                                fontSize: 14,
                            }}>{shopItem.shop_item.name} | {shopItem.shop_item.description} | {shopItem.quantity}x {shopItem.price}</PlaceText>
                        })}
                        <PlaceText style={{
                            color: PlaceColors(findifyDataContext).text.get(),
                            fontSize: 14,
                            marginLeft: 'auto'
                        }}>Total: {parseFloat(selectedOrder?.total).toFixed(2)}</PlaceText>
                    </View>
                </View>
            </View>
        </View>
    </FindifyBasicModal>
}
